import React, { useEffect } from "react";
import { ICheckBoxGroupForFakeTableLineProps } from "../../../../../type/componentsType/TkCheckbox";
import { Box, FormHelperText } from "@mui/material";
import TkCheckbox from "../../../TkCheckbox";
import _ from "lodash";
import "./_style.scss";

const CheckBoxGroupForFakeTableLine: React.FC<
  ICheckBoxGroupForFakeTableLineProps
> = (props) => {
  const {
    checkBoxList,
    onChange,
    wantToSetValue,
    error,
    errorMessage,
    onGetValue,
  } = props;
  const [checkedBox, setCheckedBox] = React.useState(wantToSetValue || []);

  useEffect(() => {
    if (_.isEqual(wantToSetValue, checkedBox)) return;

    setCheckedBox(wantToSetValue || []);
    onChange && onChange(wantToSetValue ?? []);
    onGetValue && onGetValue(wantToSetValue ?? []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wantToSetValue]);

  const handleCheckBoxChange =
    (key: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
      const newCheckBox = event.target.checked
        ? [...checkedBox, key]
        : Array.isArray(checkedBox)
        ? checkedBox.filter((value) => value !== key)
        : [];
      setCheckedBox(newCheckBox);

      onChange && onChange(newCheckBox);
      onGetValue && onGetValue(newCheckBox);
    };

  return (
    <Box className="checkBoxGroupForFakeTableLine">
      <Box>
        {checkBoxList?.map((checkBox, index) => {
          return (
            <TkCheckbox
              checked={checkedBox.includes(checkBox.label || index.toString())}
              label={checkBox.label}
              onChange={handleCheckBoxChange(
                checkBox.label || index.toString()
              )}
              value={checkBox.value}
              disabled={checkBox.disabled}
              key={index}
            />
          );
        })}
      </Box>
      {error && <FormHelperText error={error}>{errorMessage}</FormHelperText>}
    </Box>
  );
};

export default CheckBoxGroupForFakeTableLine;
